import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Chevron from '@/components/Ranking/Chevron'

const DropDown = styled.div`
  position: relative;
`

const Description = styled.div`
  columns: 2;
  @media (orientation: portrait) {
    columns: 1;
  }
`

const RankingDropdown = ({ allRankings, activeRankingIndex, sectionslug }) => {
  const orderedRankingwithActiveOnTop = [
    allRankings[activeRankingIndex],
    ...allRankings.filter((item, index) => index != activeRankingIndex),
  ]

  return (
    <DropDown>
      <div className="activeItem">
        <h4 className="text-2xl leading-none text-turquesa mb-2 ml-2">
          Otras carreras:
        </h4>
      </div>
      <div className="select">
        <div>
          {orderedRankingwithActiveOnTop.map((ranking, index) => {
            const { title, slug } = ranking
            if (index !== 0) {
              return (
                <Link
                  key={index}
                  to={`/${sectionslug}/${slug}/`}
                  title={title}
                  className="p-2 block">
                  <h6 className="text-4xl leading-none">{title}</h6>
                </Link>
              )
            }
          })}
        </div>
      </div>
    </DropDown>
  )
}

const RankingSelector = ({ activeRankingIndex, allRankings, sectionslug }) => {
  const { pretitle, title, description } = allRankings[activeRankingIndex]

  return (
    <div className="">
      <RankingDropdown
        allRankings={allRankings}
        activeRankingIndex={activeRankingIndex}
        sectionslug={sectionslug}
      />
    </div>
  )
}

export default RankingSelector
